import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCircleBanSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCircleBanSign"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C9.37665 21.5 7.00165 20.4367 5.28249 18.7175C3.56332 16.9984 2.5 14.6234 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C14.6234 2.5 16.9984 3.56332 18.7175 5.28249C20.4367 7.00165 21.5 9.37665 21.5 12Z" stroke="currentColor" strokeLinecap="round"/><Path d="M18.4413 5.55859L5.46924 18.5307" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconCircleBanSign;
